import { atom } from "recoil";

export const recognitionTextState = atom({
  key: "recognitionTextState",
  default: "",
});
